import { Text, Tooltip } from "@aurem/ui";
import { GitBranch } from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import { formatDate } from "utils/dates";

export type WorkflowConfigPin = {
  commitSha?: string | null;
  versionAt?: string | null;
};

const SHORT_SHA_LENGTH = 7;

export const WorkflowRunVersionCell = ({
  pin,
  dbVersion,
  isConfigRun,
}: {
  pin: WorkflowConfigPin | null | undefined;
  dbVersion: number | null | undefined;
  isConfigRun: boolean;
}) => {
  const { t } = useI18n();

  if (!isConfigRun) {
    return dbVersion === null || dbVersion === undefined
      ? "-"
      : `v${String(dbVersion)}`;
  }

  const label = pin?.versionAt
    ? formatDate(pin.versionAt, "dd MMM yyyy")
    : pin?.commitSha?.slice(0, SHORT_SHA_LENGTH) || "-";

  return (
    <Tooltip
      content={
        <Text size="xs">
          {t("apps.admin.internalResources.workflowRun.sources.config")}
          {pin?.commitSha
            ? ` · ${pin.commitSha.slice(0, SHORT_SHA_LENGTH)}`
            : ""}
        </Text>
      }
    >
      <div className="inline-flex items-center gap-1 cursor-pointer">
        <GitBranch size={14} className="text-neutral-500" />
        {label}
      </div>
    </Tooltip>
  );
};
